import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function CheckmarkCircle2Outline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_65)'>
        <path
          d='M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z'
          fill={color}
        />
        <path
          d='M14.7002 8.39005L10.9202 13.3901L9.29019 11.2801C9.12708 11.0705 8.88742 10.9344 8.62393 10.9016C8.36044 10.8688 8.09471 10.9419 7.88519 11.1051C7.67567 11.2682 7.53952 11.5078 7.5067 11.7713C7.47389 12.0348 7.54708 12.3005 7.71019 12.5101L10.1402 15.6201C10.2344 15.7392 10.3544 15.8354 10.4913 15.9012C10.6282 15.9671 10.7783 16.0009 10.9302 16.0001C11.0829 15.9997 11.2335 15.9643 11.3705 15.8967C11.5074 15.8291 11.627 15.7311 11.7202 15.6101L16.2902 9.61005C16.452 9.39788 16.5228 9.13013 16.4872 8.8657C16.4516 8.60128 16.3124 8.36184 16.1002 8.20005C15.888 8.03827 15.6203 7.9674 15.3558 8.00303C15.0914 8.03867 14.852 8.17788 14.6902 8.39005H14.7002Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_65'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
